import React, { useEffect, useState, useRef } from "react";
import styles from "./NavigationPanel.module.css";
import Logo from "../icons/Logo";
import Sidebar from "./Sidebar";
import DownArrow from "../icons/DownArrow";
import Chat from "../icons/Chat";
import getHeaderData from "../apis/getHeader";
import getCount from "../apis/getCount";
import { API_HEADERS, extractDomain, MIDDLEWARE } from "../utils";
import getChatServiceCheck from "../apis/getChatServiceCheck";
import getChatCount from "../apis/getChatCount";
import AddCookieScriptToHead from "./AddCookieScript";
import KnowledgeHub from "../icons/KnowledgeHub";
import Cookies from "js-cookie";
import { cleverTapTracking } from "@foundit/clevertap";
import {GenericDownload} from "@foundit/genericdownload/dist/GenericDownload.js"
import "@foundit/genericdownload/dist/GenericDownload.css";
import DownloadIcon from "../icons/DownloadIcon";

const NavigationPanel = ({
  userData,
  middleware,
  environment = "PROD",
  page_name,
  cooldown_time,
  isClevertapOn = true,
  extra_params = {},
  navDownloadIconRef
}) => {
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [headerRes, setHeaderRes] = useState(null);
  const [count, setCount] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [chatCount, setChatCount] = useState(0);
  const [showSkillAssessment, setShowSkillAssessment] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const prevUserData = useRef(userData); // Added ref to track previous data for infinite loop prevention
  const [chatInitialized, setChatInitialized] = useState(false);
  // console.log("💡 [HeaderWeb] passing navDownloadIconRef to NavigationPanel", navDownloadIconRef);
  const [downloadsData, setDownloadsData] = useState({});


  useEffect(() => {
    const fetchPollingData = async () => {
      const stored = sessionStorage.getItem("dowloadsData");
      if (!stored || stored === "{}") return;
  
      let parsed = {};
      try {
        parsed = JSON.parse(stored);
      } catch {
        return;
      }
  
      const hasInProgress = Object.values(parsed).some(
        (item) => item?.status === "InProgress"
      );
  
      if (!hasInProgress) return;
  
      try {
        const response = await fetch(
          `${middleware || MIDDLEWARE}/edge-folder-management/api/polling/excel`,
          {
            method: "POST",
            headers: {
              ...API_HEADERS,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(Object.keys(parsed))
          }
        );
  
        if (!response.ok) throw new Error("Polling failed");
  
        const data = await response.json();
        if (data && Object.keys(data).length > 0) {
          const json = JSON.stringify(data);
          sessionStorage.setItem("dowloadsData", json);
  
          const channel = new BroadcastChannel("downloads-sync");
          channel.postMessage({ type: "SYNC_DOWNLOADS", payload: json });
          channel.close();
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    };
  
    const checkAndStartPolling = () => {
      const existing = sessionStorage.getItem("dowloadsData");
      if (!existing || existing === "{}") return;
  
      fetchPollingData();
      const intervalId = setInterval(fetchPollingData, 30000);
      return intervalId;
    };
  
    let checkInterval = setInterval(() => {
      const exists = sessionStorage.getItem("dowloadsData");
      if (exists && exists !== "{}") {
        const pollInterval = checkAndStartPolling();
        clearInterval(checkInterval);
        checkInterval = null;
        return () => clearInterval(pollInterval);
      }
    }, 500);
  
    return () => {
      if (checkInterval) clearInterval(checkInterval);
    };
  }, []);
  



  useEffect(() => {
    const channel = new BroadcastChannel("downloads-sync");
    let lastSessionValue = sessionStorage.getItem("dowloadsData") || "{}";
  
    channel.onmessage = (event) => {
      const { type, payload } = event.data || {};
  
      if (type === "SYNC_DOWNLOADS" && payload) {
        const prevStored = sessionStorage.getItem("dowloadsData") || "{}";
        if (prevStored !== payload) {
          sessionStorage.setItem("dowloadsData", payload);
          const parsed = JSON.parse(payload);
          setDownloadsData((prev) => {
            const prevStr = JSON.stringify(prev);
            return prevStr !== payload ? parsed : prev;
          });
          lastSessionValue = payload;
        }
      }
  
      if (type === "REQUEST_INITIAL_SYNC") {
        const current = sessionStorage.getItem("dowloadsData") || "{}";
        if (current !== "{}") {
          channel.postMessage({ type: "INITIAL_SYNC", payload: current });
        }
      }
  
      if (type === "INITIAL_SYNC" && payload) {
        sessionStorage.setItem("dowloadsData", payload);
        setDownloadsData(JSON.parse(payload));
        lastSessionValue = payload;
      }
    };
  
    const interval = setInterval(() => {
      const current = sessionStorage.getItem("dowloadsData") || "{}";
  
      if (current !== lastSessionValue) {
        channel.postMessage({ type: "SYNC_DOWNLOADS", payload: current });
        lastSessionValue = current;
      }
  
      const parsed = JSON.parse(current);
      setDownloadsData((prev) => {
        const prevStr = JSON.stringify(prev);
        const newStr = JSON.stringify(parsed);
        return prevStr !== newStr ? parsed : prev;
      });
    }, 500);
  
    if (!sessionStorage.getItem("dowloadsData") || sessionStorage.getItem("dowloadsData") === "{}") {
      channel.postMessage({ type: "REQUEST_INITIAL_SYNC" });
    }
  
    return () => {
      clearInterval(interval);
      channel.close();
    };
  }, []);
  
  
  
  // useEffect(() => {
  //   const channel = new BroadcastChannel("already-downloaded-sync");
  
  //   channel.onmessage = (event) => {
  //     const { type, payload } = event.data || {};
  
  //     if (
  //       (type === "SYNC_ALREADY_DOWNLOADED" || type === "INITIAL_SYNC_ALREADY_DOWNLOADED") &&
  //       payload
  //     ) {
  //       sessionStorage.setItem("alreadyDownloaded", payload);
  //     }
  
  //     if (type === "REQUEST_INITIAL_SYNC_ALREADY_DOWNLOADED") {
  //       const current = sessionStorage.getItem("alreadyDownloaded") || "[]";
  //       if (current !== "[]") {
  //         channel.postMessage({ type: "INITIAL_SYNC_ALREADY_DOWNLOADED", payload: current });
  //       }
  //     }
  //   };
  
  //   const alreadyDownloadedRawInit = sessionStorage.getItem("alreadyDownloaded") || "[]";
  //   if (alreadyDownloadedRawInit === "[]") {
  //     channel.postMessage({ type: "REQUEST_INITIAL_SYNC_ALREADY_DOWNLOADED" });
  //   }
  
  //   if (!downloadsData || Object.keys(downloadsData).length === 0) return;
  
  //   const alreadyDownloaded = JSON.parse(sessionStorage.getItem("alreadyDownloaded") || "[]");
  //   const newlyDownloaded = [];
  
  //   Object.entries(downloadsData).forEach(([key, entry]) => {
  //     const { emailLink } = entry || {};
  //     if (!emailLink) return;
  
  //     if (!alreadyDownloaded.includes(key)) {
  //       const link = document.createElement("a");
  //       link.href = emailLink;
  //       link.download = "";
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  
  //       newlyDownloaded.push(key);
  //     }
  //   });
  
  //   if (newlyDownloaded.length > 0) {
  //     const updated = Array.from(new Set([...alreadyDownloaded, ...newlyDownloaded]));
  //     const updatedStr = JSON.stringify(updated);
  //     sessionStorage.setItem("alreadyDownloaded", updatedStr);
  //     channel.postMessage({ type: "SYNC_ALREADY_DOWNLOADED", payload: updatedStr });
  //   }
  
  //   return () => {
  //     channel.close();
  //   };
  // }, [downloadsData]);

  useEffect(() => {
    const channel = new BroadcastChannel("already-downloaded-sync");
  
    channel.onmessage = (event) => {
      const { type, payload } = event.data || {};
  
      if (
        (type === "SYNC_ALREADY_DOWNLOADED" || type === "INITIAL_SYNC_ALREADY_DOWNLOADED") &&
        payload
      ) {
        sessionStorage.setItem("alreadyDownloaded", payload);
      }
  
      if (type === "REQUEST_INITIAL_SYNC_ALREADY_DOWNLOADED") {
        const current = sessionStorage.getItem("alreadyDownloaded") || "[]";
        if (current !== "[]") {
          channel.postMessage({
            type: "INITIAL_SYNC_ALREADY_DOWNLOADED",
            payload: current,
          });
        }
      }
    };
  
    const alreadyDownloadedRawInit = sessionStorage.getItem("alreadyDownloaded") || "[]";
    if (alreadyDownloadedRawInit === "[]") {
      channel.postMessage({ type: "REQUEST_INITIAL_SYNC_ALREADY_DOWNLOADED" });
    }
  
    if (!downloadsData || Object.keys(downloadsData).length === 0) return;
  
    const alreadyDownloaded = JSON.parse(sessionStorage.getItem("alreadyDownloaded") || "[]");
    const newlyDownloaded = [];
  
    Object.entries(downloadsData).forEach(([key, entry]) => {
      const { emailLink } = entry || {};
      if (!emailLink) return;
  
      const lockKey = `downloadInProgress-${key}`;
  
      // skip if already downloaded or locked
      if (alreadyDownloaded.includes(key) || localStorage.getItem(lockKey) === "true") return;
  
      // lock this key
      localStorage.setItem(lockKey, "true");
  
      // perform download
      const link = document.createElement("a");
      link.href = emailLink;
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      newlyDownloaded.push(key);
    });
  
    if (newlyDownloaded.length > 0) {
      const updated = Array.from(new Set([...alreadyDownloaded, ...newlyDownloaded]));
      const updatedStr = JSON.stringify(updated);
  
      // update alreadyDownloaded before broadcasting
      sessionStorage.setItem("alreadyDownloaded", updatedStr);
  
      setTimeout(() => {
        channel.postMessage({
          type: "SYNC_ALREADY_DOWNLOADED",
          payload: updatedStr,
        });
  
        // unlock after safe delay
        newlyDownloaded.forEach((key) => {
          const lockKey = `downloadInProgress-${key}`;
          localStorage.removeItem(lockKey);
        });
      }, 200); // 200ms delay to ensure state write before broadcast
    }
  
    return () => {
      channel.close();
    };
  }, [downloadsData]);
  
  
  
  const mongoKeys = Object.keys(downloadsData);
const a =Object.values(downloadsData)
  const isBlinkTrue =
    mongoKeys.length > 0 &&
    Object.values(downloadsData).some((item) => item.status === "InProgress");
console.log({isBlinkTrue,a,})
  useEffect(() => {
    setIsClient(true);
    setCurrentUrl(typeof window !== "undefined" ? window.location.href : "");
  }, []);
  useEffect(() => {
    console.log("💡 [NavigationPanel] navDownloadIconRef.current:", navDownloadIconRef?.current);
  }, [navDownloadIconRef?.current]);
  
  const knowledgeHubUrl = currentUrl.includes(".in")
    ? "https://www.foundithub.com/"
    : currentUrl.includes("gulf")
    ? "https://gulf.foundithub.com/ "
    : "https://sea.foundithub.com/";

  const handlePreventDefaultClick = (e) => {
    e.preventDefault();
  };

  const responseOfEdge = {
    new_search_beta_customer: true,
    LOGOUT: {
      Logout: `${extractDomain()}/logout`,
    },
    JOBPOSTING: {
      "Manage Job Posting": `${extractDomain()}/edge/managejobposting`,
      "Social Jobs Check": false,
      "Post Job": `${extractDomain()}/edge/jobposting/new-job-posting?origin=Header menu`,
      "Manage Screening Questions": `${extractDomain()}/edge/jobposting/manage-questionnaire`,
    },
    SEARCH: {
      "Manage Saved Search": `${extractDomain()}/edge/foldermanagement/manage-save-search`,
      Search: `${extractDomain()}/edge/recruiter/search-v1`,
    },
    DASHBOARD: `${extractDomain()}/edge/dashboard/`,
    REPORTS: {
      "Contacted Profiles": {
        "SMS Sent": `${extractDomain()}/v2/usagereport/sent_sms.html`,
        "Foundit Mail Sent": `${extractDomain()}/v2/usagereport/email_sent_usage.html`,
      },
      "Forward Resume": `${extractDomain()}/v2/usagereport/forward_resume_usage.html`,
      "Download Excel": `${extractDomain()}/v2/usagereport/excel_download.html`,
      "Resume database": `${extractDomain()}/v2/usagereport/resume_database_usage.html`,
      "Job Posting": `${extractDomain()}/v2/usagereport/job_posting_usage.html`,
      "Account Login": `${extractDomain()}/v2/usagereport/ac_login_usage_report.html`,
    },
    CHAT: `${extractDomain()}/v4/mychatpage?platform=recruiter`,
    CAMPAIGNS: {
      "Campaign List": `${extractDomain()}/edge/recruiter-outreach-email/campaing/listing`,
    },
    USERMANAGEMENT: {
      "Access & settings": `${extractDomain()}/edge/user-management`,
      Feedback: `${extractDomain()}/v2/feedback.html`,
      "Knowledge Hub": "",
      "foundit shortcuts": `${extractDomain()}/v2/accountsettings/monster_shortcuts.html`,
      "Company profile": `${extractDomain()}/v2/accountsettings/modify_comp_profile.html`,
      "Change password": `${extractDomain()}/v2/accountsettings/change_password.html`,
      "Manage login access": `${extractDomain()}/v2/accountsettings/manage_login_access.html`,
      FAQs: `${extractDomain()}/SelfHelp/#category=`,
      "Manage users": `${extractDomain()}/v2/accountsettings/manage_user.html`,
      "Manage letters": `${extractDomain()}/v2/accountsettings/manage_letters.html`,
    },
    ADDITIONAL: {
      "Recruiter Image":
        "https://media.foundit.in/monster_2012/boy_100x100.jpg",
      Email: "neeraj.agarwal@foundit.ai",
      "Non Transparent Logo":
        "https://media.foundit.in/recruiter_2015/india/images/found_logo_n.png",
      "Transparent Logo":
        "https://media.foundit.in/recruiter_2015/india/images/logo_n.png",
      recruiter_id: 571969,
      corp_id: 328513,
      mobile: "9711843454",
      username: "xftxhemantxinx01",
      Name: "Hemant",
    },
    FOLDER: {
      "Manage folders": `${extractDomain()}/edge/foldermanagement/manage-folder`,
    },
    tracking_id: "8E9D37B9E1D9302DC09C6D174B761040",
  };

  useEffect(() => {
    if (isClient) {
      const host =
        typeof window !== "undefined" &&
        window.location.hostname === "localhost"
          ? "recruiter.foundit.in"
          : window.location.hostname;

      const hostTld = host.split(".").splice(-1)[0];
      setShowSkillAssessment(hostTld === "in");
    }
  }, [isClient]);

  useEffect(() => {
    let intervalId;
    const CHAT_INTERVAL = 5 * 60 * 1000; // 5 minutes in milliseconds

    // Utility to set items in sessionStorage or cookies
    const setItems = (key, value) => {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem(key, JSON.stringify(value));
      } else {
        Cookies.set(key, JSON.stringify(value), { expires: 1 / 48 }); // 30 minutes
      }
    };

    // Utility to get items from sessionStorage or cookies
    const getItems = (key) => {
      if (typeof sessionStorage !== "undefined") {
        const value = sessionStorage.getItem(key);
        if (value) {
          return JSON.parse(value);
        }
      }
      const cookieValue = Cookies.get(key);
      return cookieValue ? JSON.parse(cookieValue) : null;
    };

    const fetchChatService = async () => {
      try {
        const res = await getChatServiceCheck(
          middleware,
          {
            channelId: userData.channel_id || 1,
            corpId: userData.corp_id || 1,
            recruiterId: userData.recruiter_id || 1,
            subChannelId: userData.subhchannel_id || 1,
          },
          userData.tracking_id || "1"
        );

        if (res && res.serviceEnabled) {
          setItems("chatServiceEnabled", true);
          setItems("lastChatFetchTime", Date.now());
          fetchChatCount();
          setShowChat(true); // Update showChat directly from the fetch response
          startChatCountInterval();
        } else {
          setItems("chatServiceEnabled", false);
          setShowChat(false); // Disable chat if service is not enabled
        }
      } catch (err) {
        if (err && err.error && err.error.status === 404) {
          console.log("Chat service not found (404). Skipping chat feature.");
          setItems("chatServiceEnabled", false);
          setShowChat(false); // Disable chat if service is not found
        } else {
          console.error("Error in chat service check:", err);
        }
      }
    };

    const fetchChatCount = async () => {
      try {
        const chatData = await getChatCount(
          middleware,
          userData.recruiter_id,
          userData.channel_id,
          userData.subhchannel_id,
          userData.corp_id
        );

        const unreadCount = (chatData && chatData.unreadCount) || 0;
        setChatCount(unreadCount);
        setShowChat(true);
        setItems("chatCount", unreadCount); // Store chat count in session or cookies
        setItems("lastChatFetchTime", Date.now());
      } catch (err) {
        console.error("Error fetching chat count:", err);
      }
    };

    const startChatCountInterval = () => {
      intervalId = setInterval(() => {
        const chatServiceEnabled = getItems("chatServiceEnabled");
        if (chatServiceEnabled) {
          const lastFetchTime = getItems("lastChatFetchTime");
          const currentTime = Date.now();

          if (!lastFetchTime || currentTime - lastFetchTime >= CHAT_INTERVAL) {
            fetchChatCount();
          }
        }
      }, CHAT_INTERVAL);
    };

    if (isClient && userData && userData.recruiter_id) {
      const chatServiceEnabled = getItems("chatServiceEnabled");
      const storedChatCount = getItems("chatCount");

      if (chatServiceEnabled) {
        setShowChat(true); // Enable chat if it was enabled previously
        setChatCount(storedChatCount || 0); // Restore chat count from session/cookies

        const lastFetchTime = getItems("lastChatFetchTime");
        const currentTime = Date.now();

        if (!lastFetchTime || currentTime - lastFetchTime >= CHAT_INTERVAL) {
          fetchChatCount();
        }
        startChatCountInterval();
      } else if (chatServiceEnabled === null) {
        // Call fetchChatService if chatServiceEnabled is not set
        fetchChatService();
      } else {
        setShowChat(false); // Disable chat if it was disabled previously
      }
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isClient, userData && userData.recruiter_id, cooldown_time]);

  const platformGuideStyles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "4px 8px",
      gap: "4px",
      borderRadius: "26px",
      backgroundColor: "transparent",
      fontSize: "14px",
      fontWeight: "500",
      height: "32px",
      width: "138px",
      color: "#161616",
      cursor: "pointer",
      outline: "none",
      position: "relative",
    },
    link: {
      textDecoration: "none",
      color: "#161616",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      padding: "0px",
      fontFamily: "Noto Sans, sans-serif",
    },
    icon: {
      fontSize: "16px",
      display: "flex",
      alignItems: "center",
    },
    borderOverlay: {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: "26px",
      padding: "1px",
      background:
        "linear-gradient(90deg, rgba(225, 25, 160, 0.8) 0%, #6E00BE 100%)",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "destination-out",
      maskComposite: "exclude",
      pointerEvents: "none",
    },
  };
  useEffect(() => {
    if (
      isClevertapOn &&
      isClient &&
      page_name &&
      environment &&
      userData &&
      userData.recruiter_id
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      const origin = urlParams.get("origin");

      const updatedExtraParams = { ...extra_params, ...(origin && { origin }) };

      cleverTapTracking({
        userData: userData,
        pageName: page_name,
        environment: environment,
        extra_params: updatedExtraParams,
      });
    }
  }, [
    isClient,
    userData && userData.recruiter_id,
    page_name,
    environment,
    isClevertapOn,
  ]);

  const BlinkingDot = ({ isBlink = false }) => {
      console.log({isBlink})
    
  
    return (
      <div
        className={isBlink ? `${styles["blinker_blinking-dot"]} ${styles["blinkblink"]}` : `${styles["blinkblink"]}` }
      />
    );
  };
  if (!isClient) {
    return null;
  }
  
  const yourApiData={
    "67e5c702a0a4892d07fc586d": {
      folderName:"qwerty1",
      folderId: 79234429,
      emailLink:
        "https://cdn.foundit.in/edge-fm/V2/598384/Folder23_2025-03-28_79234429%2814%29.xlsx?se=2025-04-03T21%3A47%3A03Z&sp=r&sv=2023-11-03&sr=b&sig=pcBr22aKHEY5eapnvoAswTWXw%2BZtrZA1kGj%2BRlsgr3k%3D",
      exception: false,
      currentCountOfProfiles: 6,
      totalProfiles: 13,
      status: "Completed",
    },
    "679ae2a204d06918a7c81ba8": {
      folderName:"qwerty2",
      folderId: 79237035,
      emailLink: null,
      exception: true,
      currentCountOfProfiles: null,
      totalProfiles: null,
      status: "Failed",
    },
    "67e5ccc53e369671110e5daf": {
      folderName:"qwerty3",
      folderId: 79234429,
      emailLink: null,
      exception: false,
      currentCountOfProfiles: 6,
      totalProfiles: 6,
      status: "InProgress",
    },
    "67e5ccef3e369671110e5db0": {
      folderName:"qwerty4",
      folderId: 79234429,
      emailLink:
        "https://cdn.foundit.in/edge-fm/V2/598384/Folder23_2025-03-28_79234429%2814%29.xlsx?se=2025-04-03T21%3A47%3A03Z&sp=r&sv=2023-11-03&sr=b&sig=pcBr22aKHEY5eapnvoAswTWXw%2BZtrZA1kGj%2BRlsgr3k%3D",
      exception: false,
      currentCountOfProfiles: 6,
      totalProfiles: 6,
      status: "Completed",
    },
  };
 
  console.log("hgfjhkj",isDownloadOpen)
  return (
    <>{isDownloadOpen &&<GenericDownload 
      isOpen={isDownloadOpen}
        onClose={() => setIsDownloadOpen(false)}
        data={yourApiData}
        />}
    <div
      className={styles["headerabcd"]}
      style={{ fontFamily: "Noto Sans, sans-serif" }}
    >
      
      <AddCookieScriptToHead />
      <div className={styles["header-left-menu"]}>
        {responseOfEdge && responseOfEdge["DASHBOARD"] && (
          <a
            style={{
              padding: "15px 40px 15px 20px",
              display: "flex",
              textDecoration: "none",
            }}
            href={responseOfEdge["DASHBOARD"]}
          >
            <Logo />
          </a>
        )}
        <ul className={styles["menu"]}>
          {responseOfEdge &&
            responseOfEdge["SEARCH"] &&
            Object.keys(responseOfEdge["SEARCH"]).length > 0 && (
              <li className={styles["dropdown"]}>
                <a
                  style={{
                    display: "flex !important",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                  href="/#"
                  onClick={handlePreventDefaultClick}
                >
                  Search <DownArrow />
                </a>
                <ul className={styles["submenu"]}>
                  {responseOfEdge["SEARCH"]["Search"] && (
                    <li>
                      <a href={responseOfEdge["SEARCH"]["Search"]}>Search</a>
                    </li>
                  )}
                  {responseOfEdge["SEARCH"]["Manage Saved Search"] && (
                    <li>
                      <a href={responseOfEdge["SEARCH"]["Manage Saved Search"]}>
                        Saved searches
                      </a>
                    </li>
                  )}
                </ul>
              </li>
            )}
          {responseOfEdge &&
            responseOfEdge["JOBPOSTING"] &&
            Object.keys(responseOfEdge["JOBPOSTING"]).length > 0 && (
              <li className={styles["dropdown"]}>
                <a
                  style={{
                    display: "flex !important",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                  href="/#"
                  onClick={handlePreventDefaultClick}
                >
                  Job Posting <DownArrow />
                </a>
                <ul className={styles["submenu"]}>
                  {responseOfEdge["JOBPOSTING"]["Post Job"] && (
                    <li>
                      <a href={responseOfEdge["JOBPOSTING"]["Post Job"]}>
                        Post a job
                      </a>
                    </li>
                  )}
                  {userData && userData["Social Jobs"] && (
                    <li>
                      <a href={userData["Social Jobs"]}>Social Jobs</a>
                    </li>
                  )}
                  {responseOfEdge["JOBPOSTING"]["Manage Job Posting"] && (
                    <li>
                      <a
                        href={
                          responseOfEdge["JOBPOSTING"]["Manage Job Posting"]
                        }
                      >
                        Manage jobs
                      </a>
                    </li>
                  )}
                  {responseOfEdge["JOBPOSTING"][
                    "Manage Screening Questions"
                  ] && (
                    <li>
                      <a
                        href={
                          responseOfEdge["JOBPOSTING"][
                            "Manage Screening Questions"
                          ]
                        }
                      >
                        Manage questionnaires
                      </a>
                    </li>
                  )}
                </ul>
              </li>
            )}
          {responseOfEdge &&
            responseOfEdge["CAMPAIGNS"] &&
            responseOfEdge["CAMPAIGNS"]["Campaign List"] && (
              <li>
                <a href={responseOfEdge["CAMPAIGNS"]["Campaign List"]}>
                  Campaign
                </a>
              </li>
            )}
          {responseOfEdge &&
            responseOfEdge["FOLDER"] &&
            responseOfEdge["FOLDER"]["Manage folders"] && (
              <li>
                <a href={responseOfEdge["FOLDER"]["Manage folders"]}>Folders</a>
              </li>
            )}
          {showSkillAssessment && (
            <li>
              <a
                href={`https://recruiter.foundit.in/skillyst/`}
                target="_blank"
                rel="noreferrer"
              >
                Skill Assessment
              </a>
            </li>
          )}
          <li>
            <a href={`${extractDomain()}/edge/reports`}>Reports</a>
          </li>
        </ul>
      </div>
      <div className={styles["header-right-menu"]}>
        <ul className={styles["menu"]}>
          <li>
            <div style={platformGuideStyles.container}>
              <div style={platformGuideStyles.borderOverlay}></div>
              <div
                onClick={() => {
                  window.open(knowledgeHubUrl, "_blank");
                }}
                target="_blank"
                rel="noreferrer"
                style={platformGuideStyles.link}
              >
                <div style={platformGuideStyles.icon}>
                  <KnowledgeHub />
                </div>
                Platform Guide
              </div>
            </div>
            <div ref={navDownloadIconRef} style={{ margin: "auto", padding: "15px",cursor:mongoKeys.length > 0  ?"pointer":"not-allowed" }} onClick={()=>setIsDownloadOpen(!isDownloadOpen)}>
              <DownloadIcon />
            </div>{mongoKeys.length > 0 &&
            <BlinkingDot isBlink={isBlinkTrue}/> }
            {showChat && <div style={{ margin: "auto", padding: "20px 0px"}}><a
            style={{padding:"0px"}}
                href={`${
                  userData
                    ? userData["chat_url"]
                    : "https://recruiter.foundit.in/v4/mychatpage?platform=recruiter"
                }`}
                // style={{ marginTop: "2px" }}
                target={"_blank"}
                rel="noreferrer"
              >
                <div
                  chat-notification-count={chatCount}
                  className={chatCount ? styles["chat-count"] : ""}
                >
                  <Chat />
                </div>
              </a>
              </div>}
          </li>
          {/* {showChat && (
            <li style={{ marginTop: "5px", cursor: "default" }}>
              
            </li>
          )} */}
          <div className={styles["vertical-line"]}></div>
          <li style={{ padding: "0 10px" }}>
            {userData && userData["Recruiter Image"] && (
              <div
                className={styles["profile-image"]}
                style={{
                  backgroundImage: `url(${userData["Recruiter Image"]})`,
                }}
              ></div>
            )}
            <a
              href="/#"
              onClick={(e) => {
                setShowModal(!showModal);
                e.preventDefault();
              }}
              style={{
                display: "flex !important",
                gap: "0px",
                flexDirection: "column",
                padding: "0px 10px",
                alignItems: "flex-start",
              }}
            >
              <span>Hello</span>
              <span>
                {userData && userData["name"]
                  ? userData["name"]
                  : userData && userData["username"]}
              </span>
            </a>
          </li>
          <Sidebar
            showModal={showModal}
            setShowModal={setShowModal}
            userManagement={
              responseOfEdge && responseOfEdge["USERMANAGEMENT"]
                ? responseOfEdge["USERMANAGEMENT"]
                : {}
            }
            image={
              userData && userData["Recruiter Image"]
                ? userData["Recruiter Image"]
                : null
            }
            email={userData ? userData["email"] : ""}
            count={count}
            name={userData ? userData["name"] : ""}
            userName={userData ? userData["username"] : ""}
            mobile={userData ? userData["mobile"] : ""}
            socialId={userData ? userData["Social Id"] : ""}
            logoutHref={
              responseOfEdge &&
              responseOfEdge["LOGOUT"] &&
              responseOfEdge["LOGOUT"]["Logout"]
                ? responseOfEdge["LOGOUT"]["Logout"]
                : "#"
            }
          />
        </ul>
      </div>
    </div>
</>  );
};

export default NavigationPanel;
